import { put, select, takeLatest } from 'redux-saga/effects'
import { IMultiSelectProps } from '../../../../components/multiSelect/MultiSelect.component'
import { INumberPadProps } from '../../../../components/numberPad/NumberPad.component'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { ISingleSelectProps } from '../../../../components/singleSelect/SingleSelect.component'
import { getCardiacSelector } from '../selectors'
import { CardiacConstants } from '../store/cardiac.constants'
import { ICardiacState } from '../store/cardiac.types'

export function* setAction() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const cardiacState: ICardiacState = yield select(getCardiacSelector)
  const { inputRows } = procedureState
  const { action } = cardiacState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === CardiacConstants.SET_LEAD_CHANGE) {
        //@ts-ignore
        input.hidden = String(action?.id) === '12-Lead EKG' ? false : true
        if (input.hidden) {
          const leadChangeProps: IMultiSelectProps = input.props as IMultiSelectProps
          leadChangeProps.savedValues = []
        }
      }
      if (input.key === CardiacConstants.SET_JOULES) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Defibrillation' || String(action?.id) === 'Cardioversion' ? false : true
        if (input.hidden) {
          const joulesProps: INumberPadProps = input.props as INumberPadProps
          joulesProps.values = []
        }
      }
      if (input.key === CardiacConstants.SET_DEFIB_TYPE) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Defibrillation' ? false : true
        if (input.hidden) {
          const defibTypeProps: ISingleSelectProps = input.props as ISingleSelectProps
          defibTypeProps.selectedOption = null
        }
      }
      if (input.key === CardiacConstants.SET_TYPE) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Defibrillation' || String(action?.id) === 'Cardioversion' ? false : true
        if (input.hidden) {
          const typeProps: ISingleSelectProps = input.props as ISingleSelectProps
          typeProps.selectedOption = null
        }
      }
      if (input.key === CardiacConstants.SET_MA) {
        const mAProps: INumberPadProps = input.props as INumberPadProps
        if (String(action?.id) === 'Internal Pacing') {
          input.hidden = false
          mAProps.label = 'Energy Setting (mA) (0 - 50)'
        } else if (String(action?.id) === 'External Pacing') {
          input.hidden = false
          mAProps.label = 'Energy Setting (mA) (0 - 200)'
        } else {
          input.hidden = true
          mAProps.values = []
        }
      }
      if (input.key === CardiacConstants.SET_HEART_RATE) {
        input.hidden =
          String(action?.id) === 'Internal Pacing' || String(action?.id) === 'External Pacing' ? false : true
        if (input.hidden) {
          const heartRateProps: INumberPadProps = input.props as INumberPadProps
          heartRateProps.values = []
        }
      }
      if (input.key === CardiacConstants.SET_PACING_MODE) {
        input.hidden =
          String(action?.id) === 'Internal Pacing' || String(action?.id) === 'External Pacing' ? false : true
        if (input.hidden) {
          const pacingModeProps: ISingleSelectProps = input.props as ISingleSelectProps
          pacingModeProps.selectedOption = null
        }
      }
      if (input.key === CardiacConstants.SET_COMPRESSION_RATE) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Mechanical CPR' ? false : true
        if (input.hidden) {
          const compressionRateProps: ISingleSelectProps = input.props as ISingleSelectProps
          compressionRateProps.selectedOption = null
        }
      }
      if (input.key === CardiacConstants.SET_MECHANICAL_CPR_TYPE) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Mechanical CPR' ? false : true
        if (input.hidden) {
          const mechCprTypeProps: ISingleSelectProps = input.props as ISingleSelectProps
          mechCprTypeProps.selectedOption = null
        }
      }
      if (input.key === CardiacConstants.SET_LOCATION) {
        //@ts-ignore
        input.hidden = String(action?.id) === 'Defibrillator Pad Application' ? false : true
        if (input.hidden) {
          const locationProps: ISingleSelectProps = input.props as ISingleSelectProps
          locationProps.selectedOption = null
        }
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionSaga() {
  yield takeLatest([CardiacConstants.SET_ACTION, CardiacConstants.SET_UPDATE_INPUT_ROWS], setAction)
}
